import { styled } from '@mui/material/styles';

export const Root = styled('div')(() => ({
	display: 'flex',
	flexDirection: 'column',
}));

export const Footer = styled('footer')(() => ({
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: 'center',
}));
